import { createContext, useEffect, useState } from "react"

import { useContext } from "react"
import { PAGINATION_KEYS } from "../constants"

const { PAGE, PAGE_SIZE } = PAGINATION_KEYS

export const defaultFiltersProviderValues = {
  searching: false,
  setSearching: () => null,
  filters: { page: { value: PAGE }, pageSize: { value: PAGE_SIZE } },
  setFilters: () => null,
  handleFilters: () => null,
  handleResetFilters: () => null,
  resetFilters: 0,
  displayFilters: false,
  filtersToShow: undefined,
}

const FiltersContext = createContext(defaultFiltersProviderValues)

const FiltersProvider = ({ children }) => {
  const [searching, setSearching] = useState(
    defaultFiltersProviderValues.searching
  )
  const [filters, setFilters] = useState(defaultFiltersProviderValues.filters)
  const [resetFilters, setResetFilters] = useState(
    defaultFiltersProviderValues.resetFilters
  )
  const [displayFilters, setDisplayFilters] = useState(
    defaultFiltersProviderValues.displayFilters
  )
  const [filtersToShow, setFiltersToShow] = useState()

  const handleFilters = (key, value, valueToShow) => {
    setFilters((state) => {
      if (value) {
        return {
          ...state,
          page: { value: PAGE },
          [key]: { value, valueToShow: valueToShow || value },
        }
      } else {
        return {
          ...Object.fromEntries(
            Object.entries(state).filter((item) => item[0] !== key)
          ),
          page: { value: PAGE },
        }
      }
    })
  }

  const handleResetFilters = () => setResetFilters((state) => state + 1)

  useEffect(() => {
    setFilters(defaultFiltersProviderValues.filters) // reset filters
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetFilters])

  useEffect(() => {
    if (filtersToShow) {
      setDisplayFilters(!!Object.keys(filtersToShow).length)
    } else {
      setDisplayFilters(false)
    }
  }, [filtersToShow])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { page, pageSize, sort, sortBy, ...rest } = filters
    if (rest) {
      setFiltersToShow(rest)
    } else {
      setFiltersToShow(undefined)
    }
  }, [filters])

  const values = {
    searching,
    filters,
    setSearching,
    setFilters,
    handleFilters,
    handleResetFilters,
    resetFilters,
    displayFilters,
    filtersToShow,
  }

  return (
    <FiltersContext.Provider value={values}>{children}</FiltersContext.Provider>
  )
}
const useFilters = () => useContext(FiltersContext)

export { FiltersContext, FiltersProvider, useFilters }
